import { ProductSizeSelectorModeEnum } from '../../domain/constants/product-size-selector.constants';
import { ProductSizeSelectorMode, SelectorProductSize } from '../../domain/models/product-size-selector.model';

import { ProductPublicConstants, ProductPublicModels } from '@features/products/product';
import { isProductSizeNotBuyableUseCase } from '@shared/product/use-cases/product-size.use-cases';

export function shouldCheckAvailabilityOnSelectUseCase(
    size: ProductPublicModels.PublicProductSize,
    mode: ProductSizeSelectorMode
): boolean {
    const availabilityKeys = [
        ProductPublicConstants.PublicProductAvailabilityEnum.COMING_SOON,
        ProductPublicConstants.PublicProductAvailabilityEnum.BACK_SOON,
        ProductPublicConstants.PublicProductAvailabilityEnum.HIDDEN,
        ProductPublicConstants.PublicProductAvailabilityEnum.SOLD_OUT,
    ];
    return isProductSizeNotBuyableUseCase([size], availabilityKeys)
    && size.isBuyable && (mode === ProductSizeSelectorModeEnum.STANDARD || mode === ProductSizeSelectorModeEnum.SELECT);
}

export function shouldSkipOnSelectUseCase(
    size: ProductPublicModels.PublicProductSize,
    mode: ProductSizeSelectorMode
): boolean {
    return isProductSizeNotBuyableUseCase(
        [size],
        [ProductPublicConstants.PublicProductAvailabilityEnum.DISABLED]
    )
    && size.isBuyable && mode === ProductSizeSelectorModeEnum.STANDARD;
}

export function mapSizesOnSelectUseCase(
    sizes: SelectorProductSize[],
    selectedSize: ProductPublicModels.PublicProductSize,
    mode: ProductSizeSelectorMode
): SelectorProductSize[] {
    return sizes.map((productSize) => {
        if (productSize.sku === selectedSize.sku) {
            if (mode !== ProductSizeSelectorModeEnum.ESSENTIAL_MULTI) {
                return {
                    ...productSize,
                    hasSelected: true,
                };
            }
            return {
                ...productSize,
                hasSelected: !selectedSize.hasSelected,
            };
        }

        if (productSize.hasSelected && mode !== ProductSizeSelectorModeEnum.ESSENTIAL_MULTI) {
            return {
                ...productSize,
                hasSelected: false,
            };
        }

        return { ...productSize };
    });
}
